"use client";

import { Clipboard, ThumbsDown, ThumbsUp } from "lucide-react";
import { Button } from "../buttons/button";
import {
  trackClientChatFeedbackCopyToClipboard,
  trackClientChatFeedbackThumbsDown,
  trackClientChatFeedbackThumbsUp,
} from "../../analytics/client/index";
import { toast } from "@drpcrd/utils/shared";

type ChatMessageActionsProps = {
  content: string;
};

const copyToClipboard = async (content: string) => {
  try {
    await navigator.clipboard.writeText(content);
    toast("Copied to clipboard!");
    trackClientChatFeedbackCopyToClipboard({ userId: null });
  } catch {
    toast.error("Failed to copy to clipboard");
  }
};

const onThumbsUp = () => {
  trackClientChatFeedbackThumbsUp({ userId: null });
  toast("Feedback sent!");
};

const onThumbsDown = () => {
  trackClientChatFeedbackThumbsDown({ userId: null });
  toast("Feedback sent!");
};

export const ChatMessageActions = ({ content }: ChatMessageActionsProps) => (
  <div className="mt-1 flex items-center gap-1">
    <Button
      className="hover:text-primary text-neutral-900 transition-colors"
      size="md"
      variant="text"
      onClick={onThumbsUp}
    >
      <ThumbsUp />
    </Button>
    <Button
      className="hover:text-primary text-neutral-900 transition-colors"
      size="md"
      variant="text"
      onClick={onThumbsDown}
    >
      <ThumbsDown />
    </Button>
    <Button
      className="hover:text-primary text-neutral-900 transition-colors"
      size="md"
      variant="text"
      onClick={() => copyToClipboard(content)}
    >
      <Clipboard />
    </Button>
  </div>
);
